export default {
  padding: '1rem',
  backgroundColor: '#FFFBF4',
  border: '1px solid #FFBA00',
  borderRadius: '10px',
  color: '#F09B00;',
  fontSize: '14px',
};
